export const iconFontAwesomeMapsRoute = (
	<i className="fa-solid fa-route"></i>
);
